class ComponentNewsletter extends Theme.Component {
  static STORAGE_KEY = "footer-newsletter-email";

  connectedCallback() {
    super.connectedCallback();

    if (!this.elements.form) {
      return;
    }

    this.addDirectEvent("submit", this.elements.form, this.remember);

    if (!this.elements.success) {
      return;
    }

    if (document.readyState === "complete") {
      this.announce();
    } else {
      window.addEventListener("load", () => this.announce(), { once: true });
    }
  }

  remember() {
    this.store(this.elements.email.value.trim());
  }

  announce() {
    const email = this.stored();

    this.store(null);

    if (!email) {
      return;
    }

    this.dispatchEvent(new CustomEvent("newsletter:subscribe", {
      bubbles: true,
      detail: { email }
    }));
  }

  stored() {
    try {
      return window.sessionStorage.getItem(ComponentNewsletter.STORAGE_KEY);
    } catch (error) {
      return null;
    }
  }

  store(email) {
    try {
      if (email) {
        window.sessionStorage.setItem(ComponentNewsletter.STORAGE_KEY, email);
      } else {
        window.sessionStorage.removeItem(ComponentNewsletter.STORAGE_KEY);
      }
    } catch (error) {
      return;
    }
  }
}

customElements.define("component-newsletter", ComponentNewsletter);
